<template>
  <textarea
    class="border border-1 px-3 py-3 placeholder-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
    v-bind:class="{ 'border-red-500': error, 'bg-gray-300': disabled }"
    v-model="localValue"
    :disabled="disabled"
    :placeholder="placeholder"
    :maxlength="maxLength"
    :rows="rows"
  ></textarea>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    value: {
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 10000,
    },
    rows: {
      type: String,
      default: '4',
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/Form/TextArea.vue